// import React, { useState } from 'react';
// import { RiLogoutCircleRLine } from 'react-icons/ri';
// import { BiSolidUserCircle } from 'react-icons/bi';
// import MenuItem from '@mui/material/MenuItem';
// import Menu from '@mui/material/Menu';
// import { useNavigate } from 'react-router-dom';
// import { PiUserCircleGearDuotone } from 'react-icons/pi';

// const AdminProfileDropDown = () => {
//     const [anchorEl, setAnchorEl] = useState(null);
//     const navigate = useNavigate();

//     const profileDropdown = (event) => {
//         setAnchorEl(event.currentTarget);
//     };

//     const profileDropdownClose = () => {
//         setAnchorEl(null);
//         navigate('/admin/user-profile');
//     };

//     const handleLogout = () => {
//         localStorage.clear();
//         profileDropdownClose();
//         navigate('/');
//     };

//     return (
//         <div>
//             <PiUserCircleGearDuotone
//                 onClick={profileDropdown}
//                 size={40}
//                 className="transition ease-in-out hover:text-[#2E3A8C] hover:duration-300 cursor-pointer"
//             />

//             <Menu
//                 id="menu-appbar"
//                 anchorEl={anchorEl}
//                 open={Boolean(anchorEl)}
//                 onClose={profileDropdownClose}
//                 anchorOrigin={{
//                     vertical: 'top',
//                     horizontal: 'right',
//                 }}
//                 transformOrigin={{
//                     vertical: 'top',
//                     horizontal: 'right',
//                 }}
//             >
//                 <MenuItem onClick={profileDropdownClose}>
//                     <BiSolidUserCircle size={22} className="mr-2" />
//                     Profile
//                 </MenuItem>

//                 <MenuItem onClick={handleLogout}>
//                     <RiLogoutCircleRLine size={20} color="red" className="mr-2" />
//                     Logout
//                 </MenuItem>
//             </Menu>
//         </div>
//     );
// };

// export default AdminProfileDropDown;

import React, { useState, useRef, useEffect } from "react";
import { RiLogoutCircleRLine, RiUserSettingsLine } from "react-icons/ri";
import { BiSolidUserCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { PiUserCircleGearDuotone } from "react-icons/pi";

const AdminProfileDropDown = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const storedData =
    JSON.parse(localStorage.getItem("Nexgen-Admin-Data")) || {};
  const fullName = storedData?.name || "Admin User";
  const userType = storedData?.userType || "admin";
  const initials = fullName
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleProfile = () => {
    setOpen(false);
    navigate("/admin/user-profile");
  };

  const handleLogout = () => {
    setOpen(false);
    localStorage.clear();
    navigate("/");
  };

  return (
    <div ref={dropdownRef} className="relative">
      {/* ── Trigger button ── */}
      <button
        onClick={() => setOpen((p) => !p)}
        className="flex items-center gap-2 px-2 py-1.5 rounded-xl transition-all duration-200"
        style={{
          background: open ? "rgba(56,224,200,0.1)" : "transparent",
          border: open
            ? "1px solid rgba(56,224,200,0.25)"
            : "1px solid transparent",
        }}
        onMouseEnter={(e) => {
          if (!open) {
            e.currentTarget.style.background = "rgba(56,224,200,0.07)";
            e.currentTarget.style.borderColor = "rgba(56,224,200,0.15)";
          }
        }}
        onMouseLeave={(e) => {
          if (!open) {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.borderColor = "transparent";
          }
        }}
      >
        {/* Avatar circle with initials */}
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0"
          style={{
            background: "linear-gradient(135deg, #38e0c8, #1ab8a4)",
            color: "#080f1e",
            boxShadow: "0 0 10px rgba(56,224,200,0.3)",
          }}
        >
          {initials}
        </div>

        {/* Name + role — hidden on very small screens */}
        <div className="hidden lg:flex flex-col items-start leading-tight">
          <span
            className="text-xs font-bold truncate max-w-[90px]"
            style={{ color: "#ffffff" }}
          >
            {fullName.split(" ")[0]}
          </span>
          <span
            className="text-[9px] font-semibold uppercase tracking-widest"
            style={{ color: "rgba(56,224,200,0.6)" }}
          >
            {userType}
          </span>
        </div>

        {/* Chevron */}
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          className="hidden lg:block flex-shrink-0 transition-transform duration-200"
          style={{
            color: "rgba(255,255,255,0.3)",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <path
            d="M2 4L6 8L10 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* ── Dropdown panel ── */}
      {open && (
        <div
          className="absolute right-0 top-full mt-2 w-52 rounded-2xl overflow-hidden"
          style={{
            background: "linear-gradient(160deg, #0d1b35 0%, #091a2e 100%)",
            border: "1px solid rgba(56,224,200,0.14)",
            boxShadow:
              "0 16px 48px rgba(0,0,0,0.5), 0 2px 8px rgba(56,224,200,0.08)",
            zIndex: 999,
          }}
        >
          {/* Profile info header */}
          <div
            className="px-4 py-3 flex items-center gap-3"
            style={{
              background:
                "linear-gradient(135deg, rgba(56,224,200,0.07) 0%, rgba(250,189,0,0.04) 100%)",
              borderBottom: "1px solid rgba(56,224,200,0.1)",
            }}
          >
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center text-sm font-bold flex-shrink-0"
              style={{
                background: "linear-gradient(135deg, #38e0c8, #1ab8a4)",
                color: "#080f1e",
                boxShadow: "0 0 14px rgba(56,224,200,0.35)",
              }}
            >
              {initials}
            </div>
            <div className="min-w-0">
              <p
                className="text-sm font-bold truncate"
                style={{ color: "#ffffff" }}
              >
                {fullName}
              </p>
              <p
                className="text-[10px] font-semibold uppercase tracking-widest truncate"
                style={{ color: "rgba(56,224,200,0.6)" }}
              >
                {userType}
              </p>
            </div>
          </div>

          {/* Menu items */}
          <div className="p-2 space-y-0.5">
            {/* Profile */}
            <button
              onClick={handleProfile}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-150"
              style={{ color: "rgba(255,255,255,0.6)" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(56,224,200,0.08)";
                e.currentTarget.style.color = "#38e0c8";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "rgba(255,255,255,0.6)";
              }}
            >
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{
                  background: "rgba(56,224,200,0.1)",
                  border: "1px solid rgba(56,224,200,0.2)",
                }}
              >
                <RiUserSettingsLine size={14} style={{ color: "#38e0c8" }} />
              </div>
              <span className="text-sm font-medium">My Profile</span>
            </button>

            {/* Divider */}
            <div
              className="my-1 mx-2"
              style={{
                height: "1px",
                background: "rgba(255,255,255,0.05)",
              }}
            />

            {/* Logout */}
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-150"
              style={{ color: "rgba(255,255,255,0.6)" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(239,68,68,0.1)";
                e.currentTarget.style.color = "#fca5a5";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "rgba(255,255,255,0.6)";
              }}
            >
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{
                  background: "rgba(239,68,68,0.1)",
                  border: "1px solid rgba(239,68,68,0.2)",
                }}
              >
                <RiLogoutCircleRLine size={14} style={{ color: "#f87171" }} />
              </div>
              <span className="text-sm font-medium">Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminProfileDropDown;
